import { css } from 'styled-components';
import { Fonts } from '..';
import { colors } from './colors';
import MediumFontWoff from './fonts/1488906/67da9da8-4b53-4407-9184-abce69bfc8b5.woff';
import MediumFontWoff2 from './fonts/1488906/e535ec76-8fc8-4985-94e6-9246a2c6b245.woff2';
import RegularFontWoff2 from './fonts/5664092/8f117883-5a7a-40c2-a28f-d0478a469f2b.woff2';
import RegularFontWoff from './fonts/5664092/93fd95fc-c11f-47be-bd25-5f5f54288ac5.woff';

const fontName = 'Helvetica Neue';
export const fontFamily = `font-family: ${fontName}, Helvetica, Arial, Sans-serif;`;

const fontWeightBold = 700;
export const fontWeightMedium = 500;
const fontWeightRegular = 400;

export const fontFaces = `
  @font-face {
    font-family: ${fontName};
    src: url(${RegularFontWoff2}) format('woff2'), url(${RegularFontWoff}) format('woff');
    font-weight: 100;
    font-style: normal;
  }

  @font-face {
    font-family: ${fontName};
    src: url(${RegularFontWoff2}) format('woff2'), url(${RegularFontWoff}) format('woff');
    font-weight: ${fontWeightRegular};
    font-style: normal;
  }

  @font-face {
    font-family: ${fontName};
    src: url(${MediumFontWoff2}) format('woff2'), url(${MediumFontWoff}) format('woff');
    font-weight: ${fontWeightMedium};
    font-style: normal;
  }
  
  @font-face {
    font-family: ${fontName};
    src: url(${MediumFontWoff2}) format('woff2'), url(${MediumFontWoff}) format('woff');
    font-weight: ${fontWeightBold};
    font-style: normal;
  }
`;

export const fonts: Fonts = {
  headingXLarge: css`
    ${fontFamily}
    font-weight: ${fontWeightMedium};
    color: ${colors.core02};

    font-size: 4.5rem; /* 72px */
    line-height: 5rem; /* 80px */
  `,
  headingLarge: css`
    ${fontFamily}
    font-weight: ${fontWeightMedium};

    font-size: 3.75rem; /* 60px */
    line-height: 3.25rem; /* 52px */
  `,
  headingMedium: css`
    ${fontFamily}
    font-weight: ${fontWeightMedium};

    font-size: 2.5rem; /* 40px */
    line-height: 3rem; /* 48px */
  `,
  headingSmall: css`
    ${fontFamily}
    font-weight: ${fontWeightMedium};
    font-size: 1.5rem; /* 24px */
    line-height: 2rem; /* 32px */
  `,
  headingXSmall: css`
    ${fontFamily}
    font-weight: ${fontWeightMedium};
    font-size: 1.25rem; /* 20px */
    line-height: 1.75rem; /* 28px */
  `,
  paragraphLarge: css`
    ${fontFamily}
    font-weight: ${fontWeightRegular};
    font-size: 1.5rem; /* 24px */
    line-height: 2rem; /* 32px */
  `,
  paragraph: css`
    ${fontFamily}
    font-weight: ${fontWeightRegular};

    font-size: 1.25rem; /* 20px */
    line-height: 2rem; /* 32px */
  `,
  paragraphSmall: css`
    ${fontFamily}
    font-weight: ${fontWeightRegular};

    font-size: 1rem; /* 16px */
    line-height: 1.5rem; /* 24px */
  `,
  paragraphStyled: css`
    ${fontFamily}
    font-weight: ${fontWeightRegular};

    font-size: 1.125rem; /* 18px */
    line-height: 1.75rem; /* 28px */
    letter-spacing: 0.125rem;
    text-transform: uppercase;
    color: ${colors.neutral03};
  `,
};
